import {SaleStatusEnum} from '../enums/sale-status.enum';

export const SaleStatusLabel = {
  [SaleStatusEnum.LEAFLET]: 'prospecto',
  [SaleStatusEnum.OPPORTUNITY]: 'oportunidad',
  [SaleStatusEnum.PROPOSAL]: 'propuesta',
  [SaleStatusEnum.HOT]: 'hot',
  [SaleStatusEnum.EARNED_CLOSURE]: 'cierres ganados',
  [SaleStatusEnum.MISSED_CLOSURE]: 'cierres perdidos'
}